export default __webpack_public_path__ + "assets/images/Seen-25332b7d40ca43aab52b438cbb57ca35.svg";